<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2021-04-27 14:54:07
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/zui.png" /></div>
      <p>zui</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zui";
const versions = [
  '2.22.0',
  '2.21.0',
  '2.20.1',
  '2.20.0',
  '2.19.0',
  '2.18.2',
  '2.18.1',
  '2.18.0',
  '2.17.2',
  '2.17.1',
  '2.17.0',
  '2.16.2',
  '2.15.1',
  '2.15.0',
  '2.14.2',
  '2.14.1',
  '2.14.0',
  '2.13.0',
  '2.12.0',
  '2.11.1',
  '2.11.0',
  '2.10.0',
  '2.8.0',
  '2.7.0',
  '2.6.9',
  '2.6.8',
  '2.6.7',
  '2.6.5',
  '2.6.4',
  '2.6.1',
  '2.6.0',
  '2.6.0-1',
  '2.3.5',
  '2.3.4',
  '2.1.9',
  '2.1.7',
  '2.0.18',
  '2.0.14',
  '2.0.13',
  '2.0.12'
]
export default {
  name: "index",
  data() {
    return {
      fileList: versions.map(v => ({
        label: v,
        linkList: [
          `${ur}/${v}/lib/index.js`,
          `${ur}/${v}/lib/theme-chalk/index.css`
        ]
      }))
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZui.vue